module.exports = __webpack_public_path__ + "img/section1-index.d55e1a34.png";